module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAAAXNSR0IArs4c6QAAAUBJREFUOBG11D1qwzAUB/D4A48hkK1HaKFLBhc8JR0y+A7deoYeoidor5FCCISOBtt4SCg5QzEJdLXxR/+vRKAaW9ZziAZbz5J+lqUnj0ZXKobK9TzvJs9zH31WcRx/q/o228zmAznOsuyjqqr3uq6/XNe9l9v66kpYDAY8Lcvyk4MrYcuynoH/0Au4uHKNCcQsZ0VRbFGdUGwYxgkvXIRhuKe4q/TCNLANN03zMYqi3UXwEFxrxmJWnJmzYM7M2XAX7jjObRAEqfg6ZbqJTs07MiLB5r2I55SKOKFLEdN9EIy1fgD2KkEp4rUU82FCcQo3gMZnKLVte54kyVGGWWvchWJpDjJKdW2Yg2rDXFQLHoL2wkNRgm26dBX81d7Q9m/32zaqbbwyj/GLzM+D/lJKF6UxShjH1Af+hH53HJTgX80Sxxd+bsLfAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/id_arrow.png
// module id = 7sUo
// module chunks = 27